// extracted by mini-css-extract-plugin
export default {"navbar-nav":"style_navbar-nav__OL4Kb","nav-item":"style_nav-item__17qsM","userAvatar":"style_userAvatar__00vQ+","initials":"style_initials__bYzRs"};